import "./Project.css";
import { CiShare1 } from "react-icons/ci";
import Slider from "react-slick";
const ProjectCard = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };
  return (
    <>
      {projects.map((data, key) => {
        return (
          <div key={key} className=" project-box p-4" data-aos="fade-up">
            <div className="position-relative project-img">
              <Slider {...settings}>
                {Array.isArray(data?.img)
                  ? data?.img?.map((img) => {
                      return (
                        <>
                          <img
                            src={"/shoyeb" + img}
                            alt="port"
                            className="rounded w-100 h-100"
                          />
                        </>
                      );
                    })
                  : ""}
              </Slider>
              <div className="project-empty"></div>
              <div className="project-content mx-auto d-flex">
                <div className="mx-auto text-center px-5 py-2">
                  <h4 className="m-0 text-capitalize">{data?.title}</h4>
                  <div> {data?.desc}</div>
                  <div className="mt-4">
                    <span className="bg-secondary p-3 rounded-circle ">
                      <a
                        href={data.link}
                        className="text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CiShare1 size={20} className="my-auto" />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ProjectCard;

const projects = [
  {
    link: "http://bidinn.in",
    img: [
      "/images/project-images/bd1.png",
      "/images/project-images/bd2.png",
      "/images/project-images/bd3.png",
      "/images/project-images/bd4.png",
      "/images/project-images/bd5.png",
      "/images/project-images/bd6.png",
    ],
    title: "Hotel Booking",
    desc: "Hotel booking with negotiate price",
  },

  {
    link: "https://school-34d9.onrender.com",
    img: [
      "/images/project-images/s1.png",
      "/images/project-images/s2.png",
      "/images/project-images/s3.png",
      "/images/project-images/s4.png",
      "/images/project-images/s5.png",
      "/images/project-images/s6.png",
    ],
    title: "School Management",
    desc: "School management with admin panel",
  },
  {
    link: "https://shoyebmd424.github.io/tutorweb2/",
    title: "Education App",
    img: [
      "/images/project-images/e1.png",
      "/images/project-images/e2.png",
      "/images/project-images/e4.png",
      "/images/project-images/e5.png",
      "/images/project-images/e6.png",
      "/images/project-images/e7.png",
    ],
    desc: "Education Website with dynamic and server configuration",
  },
  {
    link: "https://e-commerce-app-y91p.onrender.com/",
    img: [
      "/images/project-images/ec1.png",
      "/images/project-images/ec2.png",
      "/images/project-images/ec3.png",
    ],
    title: "E-commerce App",
    desc: "E-commerse App with admin panel and all functionality",
  },
  {
    link: "https://shoyebmd424.github.io/sbgym/",
    img: [
      "/images/project-images/g2.png",
      "/images/project-images/g1.png",
      "/images/project-images/g3.png",
    ],
    title: "Gym App",
    desc: "Wym App",
  },
  {
    link: "http://github.com/shoyebmd424",
    img: [
      "/images/project-images/ecc1.png",
      "/images/project-images/ecc2.png",
      "/images/project-images/ecc3.png",
      "/images/project-images/ecc4.png",
      "/images/project-images/ecc5.png",
      "/images/project-images/ecc6.png",
    ],
    title: "E Commerse App",
    desc: "E-commerse App with admin panel and all functionality",
  },
];
